import React, { useEffect, useState } from "react";
import { getBankAccounts, updateBankAccount } from "../../../services/bank";
import convertBankToPersianName from "../../../utils/convertBankToPersianName";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
export default function CardManagement() {
  const [cards, setCards] = useState([]);
  const [defaultId, setDefaultId] = useState(0);
  const isTabletOrfirst = useMediaQuery({ query: "(max-width: 768px)" });
  function handleCardsList() {
    getBankAccounts().then((data) => {
      const cardsList = data?.data?.results || [];
      setCards(cardsList);
      for (let c of cardsList) {
        if (c.default) {
          setDefaultId(c.id);
        }
      }
    });
  }
  function handleUpdateAccount(id) {
    updateBankAccount(id).then((res) => {
      if (res.status === 200 || res.status === 201) {
        toast.success("کارت پیشفرض انتخاب شد");
        handleCardsList();
      }
    });
  }
  useEffect(() => {
    handleCardsList();
  }, []);
  return (
    <div className="subsdFSFSNFS">
      <div className="card-management-title">مدیریت کارت های بانکی</div>

      <div className="card-list">
        {cards.map((item) =>
          !isTabletOrfirst ? (
            <div key={`card-${item.id}`}>
              <div className="card-item">
                <div className="card-item_number">{item.card_number}</div>
                <div className="card-item_bank">
                  <span className="card-item_bank-color">
                    {convertBankToPersianName(item.bank_name).name}
                  </span>
                  {convertBankToPersianName(item.bank_name).logo ? (
                    <img
                      className={"logo-bank-image"}
                      src={convertBankToPersianName(item.bank_name).logo}
                      alt={convertBankToPersianName(item.bank_name).name}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="card-item_bank">
                  وضعیت :{" "}
                  {item.status === 0 ? (
                    <>اولیه</>
                  ) : item.status === 1 ? (
                    <>در انتظار</>
                  ) : item.status === 2 ? (
                    <>تایید شده</>
                  ) : (
                    <>رد شده</>
                  )}{" "}
                  <span className="card-item_default">
                    {item.default && <>پیشفرض</>}
                  </span>
                </div>
                <div className="card-item_checkbox-wrapper">
                  <div
                    className="card-item_checkbox-wrapper-item"
                    onClick={() =>
                      defaultId !== item.id
                        ? handleUpdateAccount(item.id)
                        : false
                    }
                  >
                    {item.default && (
                      <span className="checkmark-icon">&#10003;</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="transactions-row">
                <div>واریزی کل : {item.deposit} تومان</div>
                <div>برداشت کل : {item.withdrawal} تومان</div>
              </div>
            </div>
          ) : (
            <div key={`card-${item.id}`}>
              <div className="card-item-mobile">
                <div className="card-item_number-mobile">
                  {item.card_number}
                </div>
                <div className="card-item_bank">
                  <div>
                    وضعیت :{" "}
                    {item.status === 0 ? (
                      <>اولیه</>
                    ) : item.status === 1 ? (
                      <>در انتظار</>
                    ) : item.status === 2 ? (
                      <>تایید شده</>
                    ) : (
                      <>رد شده</>
                    )}
                    <span className="card-item_default">
                      {" "}
                      {item.default && <>پیشفرض</>}
                    </span>
                  </div>
                  <div className="card-item_checkbox-wrapper">
                    <div
                      className="card-item_checkbox-wrapper-item"
                      onClick={() =>
                        defaultId !== item.id
                          ? handleUpdateAccount(item.id)
                          : false
                      }
                    >
                      {item.default && (
                        <span className="checkmark-icon">&#10003;</span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="transactions-row">
                  <div>
                    واریزی کل <br /> {item.deposit} تومان
                  </div>
                  <div>
                    {convertBankToPersianName(item.bank_name).name}
                    {convertBankToPersianName(item.bank_name).logo ? (
                      <img
                        className={"logo-bank-image"}
                        src={convertBankToPersianName(item.bank_name).logo}
                        alt={convertBankToPersianName(item.bank_name).name}
                      />
                    ) : (
                      <></>
                    )}
                  </div>

                  <div>
                    برداشت کل <br /> {item.withdrawal} تومان
                  </div>
                </div>
              </div>
            </div>
          )
        )}
        <div className="liadd66">
          <Link to={"/addcard"} className={"stLink"}>
            <span className="add-card-plus">
              افزودن کارت جدید
              <img src={"/images/svg/add-card-plus.svg"} alt={""} />
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
}
